<template>
  <div
    class="mouse-tip-box"
    v-show="isVisible"
    ref="mouseTip">
    <div>{{ mouseTipContent }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      mouseTipContent: ''
    }
  },
  mounted() {
    this.$eventManage.on('canvasMouseMove', this.onCanvasMouseMove)
  },
  beforeDestroy() {
    this.$eventManage.off('canvasMouseMove', this.onCanvasMouseMove)
  },
  methods: {
    onCanvasMouseMove(eventInfo) {
      let { coorInfo } = eventInfo
      let { clientX, clientY, visible, tipContent } = coorInfo
      this.isVisible = visible
      this.mouseTipContent = tipContent

      let domRef = this.$refs.mouseTip
      domRef.style.top = `${clientY}px`
      domRef.style.left = `${clientX}px`
    }
  }
}
</script>

<style lang="less" scoped>
.mouse-tip-box {
  position: absolute;
  top: 0px;
  left: 0px;
  margin-top: 10px;
  margin-left: 10px;
  padding: 10px;
  color: var(--eng-cursor-text-color);
  background: var(--base-bg-dark-color7);
  box-shadow: 0px 3px 6px var(--base-bg-dark-color8);
  text-align: left;
  z-index: 999;
}
</style>
